module.exports = __webpack_public_path__ + "static/media/kw.496fa466.svg";